import { Loader } from "components/Loader/Loader"



export const LoadingPage = () => {
    return <div className=" w-full h-full  flex justify-center items-center p-16">
        <Loader size={30} />
    </div>
}